<script setup lang="ts"></script>

<template>
	<section class="consultation-section">
		<h2 class="consultation-section__title">Бесплатная консультация</h2>
		<div class="consultation-section__description">
			Ответим на все ваши вопросы и подготовим коммерческое предложение с подробным указанием цен и
			сроками доставки
		</div>
		<div class="consultation-section__form-container">
			<FormOrderRequest :is-for-section="true" />
			<NuxtImg
				src="/images/consultation-section-bg.png"
				alt="Сотрудники отвечают на вопросы по доставке из Китая"
				densities="x1 x2"
				format="webp"
				sizes="360px xs:600px md:1200px xl:716px"
				loading="lazy"
				class="consultation-section__image-block"
			/>
		</div>
	</section>
</template>

<style lang="scss" scoped>
	.consultation-section__title {
		font-size: var(--font-size-title);
		color: var(--color-tertiary);
		font-weight: 700;
		margin-bottom: 12px;
	}
	.consultation-section__description {
		margin-bottom: 20px;
	}
	.consultation-section__form-container {
		display: grid;
		grid-template-columns: 1fr;
		gap: 20px;
	}
	.consultation-section__image-block {
		display: flex;
		border-radius: 20px;
		overflow: hidden;
		object-fit: cover;
		width: 100%;
		height: auto;
		aspect-ratio: 1.23;
	}

	@media (min-width: 1240px) {
		.consultation-section__title {
			margin-bottom: 15px;
		}
		.consultation-section__description {
			margin-bottom: 25px;
		}
		.consultation-section__form-container {
			grid-template-columns: 1fr 1fr;
			gap: 24px;
			min-height: 478px;
		}
		.consultation-section__image-block {
			height: 100%;
			border-radius: 20px;
			overflow: hidden;
			object-fit: cover;
			aspect-ratio: unset;
		}
	}
</style>
